import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import { normalizeTextUppercase } from "../utils"

export const obterPeriodicidadeAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Periodicidade/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterPeriodicidadePorPlanoAsync = async (idPlano) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Periodicidade/obterListaPorPlano/` + idPlano, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarPeriodicidadeAsync = async (descricao, quantidadeHoras) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao: normalizeTextUppercase(descricao), quantidadeHoras })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Periodicidade`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarPeriodicidadeAsync = async (id, descricao, quantidadeHoras, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao: normalizeTextUppercase(descricao), quantidadeHoras, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Periodicidade/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}
